/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Box, TagChip, Text } from '@landtrustinc/design-system';

import type { SuggestedPrompt } from '../../../types';

const promptActionStyles = css`
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  line-height: 0;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:focus-visible {
    outline: 2px solid var(--border-focus);
    outline-offset: 2px;
  }
`;

type StarterPromptsProps = {
  disabled?: boolean;
  onPromptClick?: (prompt: string) => void;
  prompts: SuggestedPrompt[];
  title: string;
};

const StarterPrompts = ({
  disabled = false,
  onPromptClick,
  prompts,
  title,
}: StarterPromptsProps) => {
  const handlePromptSelect = (prompt: SuggestedPrompt) => {
    if (disabled) return;
    onPromptClick?.(prompt.value ?? prompt.label);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="var(--spacing-4)"
      alignItems="center"
      width="100%"
    >
      <Text size="md" fontWeight="bold" color="var(--text-primary)" textAlign="center">
        {title}
      </Text>

      <Box
        display="flex"
        flexWrap="wrap"
        gap="var(--spacing-4)"
        justifyContent="center"
        width="100%"
      >
        {prompts.map((prompt) => (
          <button
            key={`${prompt.label}-${prompt.value ?? prompt.label}`}
            type="button"
            disabled={disabled}
            css={promptActionStyles}
            onClick={() => handlePromptSelect(prompt)}
          >
            <TagChip variant="success">{prompt.label}</TagChip>
          </button>
        ))}
      </Box>
    </Box>
  );
};

export default StarterPrompts;
